import {VGLawCookie} from "vglawcookie";
import {onReady} from "../../../../modules/vegas/js/util";

function ready() {
	new VGLawCookie();
}

onReady(ready);

typeof onTurboRender !== 'undefined' && onTurboRender(ready);
